var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#F5F7FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#D8E1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24437 9.60381C7.24437 9.27322 7.31914 8.97411 7.4687 8.70649C7.61825 8.43494 7.79928 8.21258 8.01181 8.03941C8.22433 7.86624 8.43685 7.69505 8.64937 7.52582C8.86583 7.35659 9.04687 7.16374 9.19248 6.94728C9.34204 6.72689 9.41681 6.48485 9.41681 6.22117C9.41681 5.88271 9.28694 5.59738 9.02719 5.36518C8.77138 5.12904 8.43882 5.01097 8.02952 5.01097C7.76977 5.01097 7.53363 5.05427 7.32111 5.14085C7.10859 5.2235 6.94329 5.32385 6.82523 5.44192C6.70716 5.55605 6.61074 5.67215 6.53596 5.79022C6.46118 5.90829 6.41002 6.01061 6.38247 6.0972L6.33525 6.22117L5.24902 5.79612C5.26477 5.74103 5.28641 5.66822 5.31396 5.5777C5.34151 5.48718 5.42612 5.32779 5.56781 5.09953C5.70949 4.87126 5.87281 4.67055 6.05779 4.49738C6.24276 4.32421 6.51038 4.16482 6.86065 4.01921C7.21091 3.87359 7.60054 3.80078 8.02952 3.80078C8.82057 3.80078 9.47191 4.02708 9.98354 4.47967C10.4952 4.92833 10.751 5.4675 10.751 6.0972C10.751 6.54192 10.6703 6.92367 10.5089 7.24245C10.3476 7.5573 10.1508 7.80918 9.9186 7.99809C9.69034 8.18306 9.45814 8.35819 9.222 8.52349C8.9898 8.68878 8.79302 8.89737 8.63166 9.14925C8.4703 9.39719 8.38962 9.69039 8.38962 10.0289V10.1469H7.3034C7.26405 9.9462 7.24437 9.76517 7.24437 9.60381ZM7.2975 12.2721C7.14007 12.1147 7.06136 11.9317 7.06136 11.7231C7.06136 11.5106 7.14007 11.3256 7.2975 11.1682C7.45492 11.0108 7.63793 10.9321 7.84651 10.9321C8.0551 10.9321 8.2381 11.0108 8.39553 11.1682C8.55295 11.3256 8.63166 11.5106 8.63166 11.7231C8.63166 11.9317 8.55295 12.1147 8.39553 12.2721C8.2381 12.4256 8.0551 12.5024 7.84651 12.5024C7.63793 12.5024 7.45492 12.4256 7.2975 12.2721Z",
    fill: "#388AF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.0f6ba61c5de6a0d32c1da96207072740.svg";
export { ForwardRef as ReactComponent };